import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import _regeneratorRuntime from "/vercel/path1/node_modules/@babel/runtime/regenerator/index.js";
import { get } from "lodash";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { Suspense } from "react";
import Loader from "../../components/Loader";
import { t } from "i18next";
var Patients = dynamic(function () {
  return import("../../components/Patients");
}, {
  ssr: false,
  loading: function loading() {
    return /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-center bold text-gray-900 dark:text-white bg-gray-100 dark:bg-gray-900 w-full h-full"
    }, /*#__PURE__*/React.createElement(Loader, {
      size: "medium",
      label: "".concat(t("loading_key"), "...")
    }));
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [require.resolveWeak("../../components/Patients")];
    }
  }
});
var PatientsPage = function PatientsPage() {
  var router = useRouter();
  var patient_uid = Number(get(router, ["query", "params", "0"], 0));
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: "".concat(t("loading_key"), "...")
  }, /*#__PURE__*/React.createElement(Patients, {
    patient_uid: patient_uid
  }));
};
export function getStaticProps(_x) {
  return _getStaticProps.apply(this, arguments);
}
function _getStaticProps() {
  _getStaticProps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(context) {
    var _context$params;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", {
            props: {
              hasShare: !!(context !== null && context !== void 0 && (_context$params = context.params) !== null && _context$params !== void 0 && _context$params.length) ? true : false
            }
          });
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _getStaticProps.apply(this, arguments);
}
export var getStaticPaths = function getStaticPaths() {
  return {
    paths: [],
    //indicates that no page needs be created at build time
    fallback: "blocking" //indicates the type of fallback
  };
};
export default PatientsPage;